export const SERVER_URL = "https://do-calculate.com/api";

export const mathCalculators = [
  {
    name: "حساب النسبة المئوية",
    link: "/calculator/ar/percentage/",
    description:
      "تستخدم هذه الحاسبة لحساب النسب المئوية والزيادة أو النقصان المئوي.",
    showMain: true,
  },
  {
    name: " حاسبة الجذور الرياضية",
    link: "/calculator/ar/roots/",
    description:
      "هذه الحاسبة المجانية للجذر تحسب الجذور للأرقام، بما في ذلك الجذور الشائعة مثل الجذر التربيعي أو الجذر التكعيبي وحساب جذر أي رقم.",
    showMain: true,
  },
  {
    name: "حاسبة حجم الأشكال الهندسية",
    link: "/calculator/ar/volumes/",
    description:
      "هذه الحاسبة المجانية تُحسب حجوم الأشكال الشائعة بما في ذلك الكرة، المخروط، المكعب، الأسطوانة، الكبسولة، الغطاء، الجذع المخروطي، الشكل البيضوي، الهرم، الانبوب والمزيد.",
    showMain: true,
  },
  {
    name: "حاسبة المثلث",
    link: "/calculator/ar/triangle/",
    description:
      "استخدم حاسبة المثلث لحساب معلومات المثلثات بسهولة، بما في ذلك أطوال الأضلاع والزوايا والمساحة، مما يسهل عمليات الرسم الهندسي وحل المسائل الرياضية. هذه الحاسبة المثلثية المجانية تقوم بحساب الأضلاع، الزوايا، المساحة، الارتفاع، المحيط، الوسيط، بالإضافة إلى قيم أخرى ورسم تخطيطي للمثلث الناتج.",
    showMain: true,
  },
  {
    name: "حاسبة مساحة الأشكال الهندسية",
    link: "/calculator/ar/areas/",
    description:
      "هذه الحاسبة تقوم بحساب مساحة عدة أشكال هندسية شائعة، بما في ذلك المستطيل، والمثلث، والمتوازي الأضلاع، والدائرة، والقطاع، الشكل البيضوي.",
    showMain: true,
  },
  {
    name: "حاسبة رتبة الوسيط",
    link: "/calculator/ar/median/",
    description:
      "حاسبة قيمة الوسيط تحسب لك رتبة الوسيط وتشرح لك الية وكيفية حسابه",
  },
  {
    name: "حاسبة محيط الأسطوانة",
    link: "/calculator/ar/cylinder-circumference/",
    description:
      "حاسبة محيط الأسطوانة تقوم بحساب محيط الأسطوانة بناءً على القطر والارتفاع.",
  },
  {
    name: "حاسبة مساحة الخزان",
    link: "/calculator/ar/tank-area/",
    description:
      "حاسبة مساحة الخزان تقوم بحساب مساحة الخزان بناءً على الأبعاد والمستطيلات المكونة للخزان.",
  },
  {
    name: "حاسبة طول ضلع المربع",
    link: "/calculator/ar/square-side-length/",
    description:
      "حاسبة طول ضلع المربع تقوم بحساب طول ضلع المربع بناءً على المساحة أو المحيط المدخلين.",
  },
  {
    name: "حاسبة نسبة الغياب ",
    link: "/calculator/ar/absence-percentage/",
    description:
      "حاسبة نسبة الغياب تقوم بحساب نسبة الغياب بناءً على عدد الحضور والغياب الكليين.",
    showMain: true,
  },
  {
    name: "حاسبة نسبة الحضور  ",
    link: "/calculator/ar/attendance-percentage/",
    description:
      "حاسبة نسبة الحضور تقوم بحساب نسبة الحضور بناءً على عدد الحضور والغياب الكليين.",
  },
  {
    name: "حاسبة نسبة النجاح و الرسوب",
    link: "/calculator/ar/success-failure-rate/",
    description:
      "حاسبة نسبة النجاح و الرسوب تقوم بحساب نسبة النجاح والرسوب بناءً على عدد الطلاب الناجحين والراسبين.",
  },
  {
    name: "احسب نسبة النجاح والفشل من عدد المحاولات",
    link: "/calculator/ar/probability/",
    description:
      "احسب نسبة النجاح والفشل من عدد المحاولات بناءً على عدد النجاحات والإجمالي.",
  },
  {
    name: "حاسبة كثافة السكان",
    link: "/calculator/ar/population-density/",
    description:
      "حاسبة كثافة السكان تقوم بحساب كثافة السكان بناءً على عدد السكان ومساحة المنطقة.",
  },
  {
    name: "حاسبة خمس المبلغ",
    link: "/calculator/ar/one-fifth/",
    description:
      "حاسبة خمس المبلغ تقوم بحساب خمس المبلغ بناءً على المبلغ الكلي المدخل.",
  },
  {
    name: "حاسبة نصف قطر الدائرة",
    link: "/calculator/ar/circle-radius/",
    description:
      "حاسبة نصف قطر الدائرة تقوم بحساب نصف قطر الدائرة باستخدام معلومات مثل طول القطر أو محيط الدائرة أو مساحة الدائرة",
  },
  {
    name: "حساب النسبة المئوية لأي رقم",
    link: "/calculator/ar/percentage_converter/percentage_list/",
    description:
      "استخدم هذه الأداة لحساب النسبة المئوية لأي رقم بين 1 و 100 بسهولة ودقة. توفر لك هذه الآلة الحاسبة طريقة سريعة وفعالة لإيجاد النسبة المئوية لأرقام معينة.",
  },
  {
    name: "حاسبة المتوسط ​​والوسيط والمنوال والنطاق",
    link: "/calculator/ar/mean-median-mode-range-calculator/",
    description:
      "تحسب هذه الآلة الحاسبة المتوسط، الوسيط، المنوال، المدى، المتوسط الهندسي، أكبر عدد، أصغر عدد، مجموع الأعداد، عدد الأرقام، وترتيب البيانات ",
  },
  {
    name: "حاسبة الدائرة",
    link: "/calculator/ar/circle-calculator/",
    description:
      "تحسب هذه الآلة الحاسبة نصف قطر وقطر ومحيط ومساحة الدائرة. حلول خطوة بخطوة.",
    showMain: true,
  },
  {
    name: "حاسبة التقريب",
    link: "/calculator/ar/rounding-calculator/",
    description:
      "تحسب هذه الآلة الحاسبة تقريب الرقم إلى أقرب عدد صحيح أو أقرب قيمة عشرية بناءً على مستوى الدقة المحدد",
  },
  {
    name: "حساب مربع العدد - حاسبة مربع الاعداد",
    link: "/calculator/ar/squared-calculator/",
    description: "تقوم هذه الآلة الحاسبة بتربيع الرقم وإظهار النتيجة",
  },
  {
    name: "حاسبة المضاعف المشترك الأصغر",
    link: "/calculator/ar/lcm-calculator/",
    description:
      "تحسب هذه الآلة الحاسبة المضاعف المشترك الأصغر لمجموعة من الأرقام",
  },
  {
    name: "حاسبة القاسم المشترك الأكبر",
    link: "/calculator/ar/gcf-calculator/",
    description:
      "تحسب هذه الآلة الحاسبة القاسم المشترك الأكبر لمجموعة من الأرقام",
  },
  {
    name: "حاسبة العوامل",
    link: "/calculator/ar/factors-calculator/",
    description: "تحسب هذه الآلة الحاسبة عوامل العدد والعوامل الأولية له",
  },
  {
    name: "حاسبة الخرسانة",
    link: "/حاسبة_الخرسانة/",
    description:
      "حاسبة الخرسانة هي أداة رقمية تساعد في تقدير كمية الخرسانة اللازمة لمشروع بناء معين،",
  },
  {
    name: "حاسبة حجم العينة",
    link: "/calculator/ar/sample-size-calculator/",
    description:
      "تحسب هذه الآلة الحاسبة الحد الأدنى لعدد العينات اللازمة لتلبية القيود الإحصائية المطلوبة.",
  },
  {
    name: "حساب ارتفاع شبه المنحرف",
    link: "/calculator/ar/trapezoid-height-calculator/",
    description: "احسب ارتفاع شبه المنحرف بناءً على مساحته وطولي قاعدتيه.",
  },
  {
    name: "حاسبة باقي القسمة",
    link: "/calculator/ar/remainder-calculator/",
    description: "احسب باقي القسمة بين عددين.",
  },
  {
    name: "حاسبة نسبة 5% من مبلغ",
    link: "/calculator/ar/5percent/",
    description:
      "تعلم كيف تقوم ب احسب نسبة 5% من مبلغ - حاسبة 5 بالمئة - حساب كم تساوي خمسة بالمئة. تقوم هذه الحاسبة بحساب قيمة ونسبة 5 بالمئة من مبلغ او قيمة معينة",
  },
  {
    name: "حاسبة نسبة 10% من مبلغ",
    link: "/calculator/ar/10percent/",
    description:
      "تعلم كيف تقوم ب احسب نسبة 10% من مبلغ - حاسبة 10 بالمئة - حساب كم تساوي عشرة بالمئة. تقوم هذه الحاسبة بحساب قيمة ونسبة 10 بالمئة من مبلغ او قيمة معينة",
  },
  {
    name: "حاسبة نسبة 15% من مبلغ",
    link: "/calculator/ar/15percent/",
    description:
      "تعلم كيف تقوم ب احسب نسبة 15% من مبلغ - حاسبة 15 بالمئة - حساب كم تساوي خمسة عشر بالمئة. تقوم هذه الحاسبة بحساب قيمة ونسبة 15 بالمئة من مبلغ او قيمة معينة",
  },
  {
    name: "حاسبة نسبة 20% من مبلغ",
    link: "/calculator/ar/20percent/",
    description:
      "تعلم كيف تقوم ب احسب نسبة 20% من مبلغ - حاسبة 20 بالمئة - حساب كم تساوي عشرون بالمئة. تقوم هذه الحاسبة بحساب قيمة ونسبة 20 بالمئة من مبلغ او قيمة معينة",
  },
  {
    name: "حاسبة نسبة 25% من مبلغ",
    link: "/calculator/ar/25percent/",
    description:
      "تعلم كيف تقوم ب احسب نسبة 25% من مبلغ - حاسبة 25 بالمئة - حساب كم تساوي خمسة وعشرون بالمئة. تقوم هذه الحاسبة بحساب قيمة ونسبة 25 بالمئة من مبلغ او قيمة معينة",
  },
  {
    name: "حاسبة نسبة 30% من مبلغ",
    link: "/calculator/ar/30percent/",
    description:
      "تعلم كيف تقوم ب احسب نسبة 30% من مبلغ - حاسبة 30 بالمئة - حساب كم تساوي ثلاثون بالمئة. تقوم هذه الحاسبة بحساب قيمة ونسبة 30 بالمئة من مبلغ او قيمة معينة",
  },
  {
    name: "حاسبة نسبة 35% من مبلغ",
    link: "/calculator/ar/35percent/",
    description:
      "تعلم كيف تقوم ب احسب نسبة 35% من مبلغ - حاسبة 35 بالمئة - حساب كم تساوي خمسة وثلاثون بالمئة. تقوم هذه الحاسبة بحساب قيمة ونسبة 35 بالمئة من مبلغ او قيمة معينة",
  },
  {
    name: "حاسبة نسبة 40% من مبلغ",
    link: "/calculator/ar/40percent/",
    description:
      "تعلم كيف تقوم ب احسب نسبة 40% من مبلغ - حاسبة 40 بالمئة - حساب كم تساوي اربعون بالمئة. تقوم هذه الحاسبة بحساب قيمة ونسبة 40 بالمئة من مبلغ او قيمة معينة",
  },
  {
    name: "حاسبة نسبة 45% من مبلغ",
    link: "/calculator/ar/45percent/",
    description:
      "تعلم كيف تقوم ب احسب نسبة 45% من مبلغ - حاسبة 45 بالمئة - حساب كم تساوي خمس واربعون بالمئة. تقوم هذه الحاسبة بحساب قيمة ونسبة 45 بالمئة من مبلغ او قيمة معينة",
  },
  {
    name: "حاسبة نسبة 75% من مبلغ",
    link: "/calculator/ar/75percent/",
    description:
      "تعلم كيف تقوم ب احسب نسبة 75% من مبلغ - حاسبة 75 بالمئة - حساب كم تساوي خمسة وسبعون بالمئة. تقوم هذه الحاسبة بحساب قيمة ونسبة 75 بالمئة من مبلغ او قيمة معينة",
  },
  {
    name: "حاسبة المصفوفات: جمع وطرح وضرب العمليات الرياضية على المصفوفات",
    link: "/calculator/ar/matrix-operations/",
    description:
      "قم بإجراء عمليات مختلفة على المصفوفات مثل الجمع، الطرح، الضرب، التبديل، والمزيد باستخدام هذه الحاسبة.",
  },
  {
    name: "حاسبة الكسور",
    link: "/calculator/ar/fractions-calculator/",
    description:
      "تقوم هذه الحاسبة بإجراء عمليات حسابية مختلفة كالجمع والضرب والطرح والقسمة على الكسور.",
  },
  {
    name: "حاسبة تبسيط الكسور",
    link: "/calculator/ar/simplify-fractions/",
    description:
      "تقوم هذه الحاسبة بتبسيط الكسور وتحويلها إلى كسور مختلطة أو عدد كسري.",
  },
  {
    name: "حاسبة اللتر",
    link: "/calculator/ar/liter-calculator/",
    description:
      "استخدم حاسبة تحويل اللترات المجانية عبر الإنترنت لتحويل وحدات حجم مختلفة إلى لترات.",
  },
  {
    name: "حاسبة ثلثي العدد - حساب ثلثين عدد ما",
    link: "/calculator/ar/twothirds-calculator/",
    description:
      "احسب ثلثي أي عدد بسهولة باستخدام حاسبة ثلثي العدد المجانية والدقيقة.",
  },
  {
    name: "حاسبة الثلث",
    link: "/calculator/ar/onethird-calculator/",
    description:
      "احسب ثلث أي عدد بسهولة باستخدام حاسبة ثلث العدد المجانية والدقيقة.",
  },
  {
    name: "حاسبة الربع - حساب ربع العدد",
    link: "/calculator/ar/quarter-calculator/",
    description:
      "احسب ربع أي عدد بسهولة باستخدام حاسبة ربع العدد المجانية والدقيقة.",
  },
  {
    name: "حاسبة زاوية المثلث",
    link: "/calculator/ar/triangle-angle-calculator/",
    description:
      "استخدم حاسبة زوايا المثلث لحساب الزوايا المجهولة في المثلث باستخدام الزوايا المعروفة. تعلم كيفية تصنيف المثلثات وحساب زواياها باستخدام القوانين الهندسية والدوال المثلثية.",
  },
  {
    name: "حاسبة قطر المربع",
    link: "/calculator/ar/square-diameter-calculator/",
    description:
      "استخدم حاسبة قطر المربع لحساب قطر المربع بسهولة ودقة. أدخل طول الضلع للحصول على القطر باستخدام الصيغة المناسبة.",
  },
  {
    name: "حساب وتر المثلث - حاسبة وتر المثلث",
    link: "/calculator/ar/hypotenuse-calculator/",
    description:
      "استخدم حاسبة الوتر لحساب طول الوتر في المثلث القائم الزاوية بسهولة ودقة.",
  },
  {
    name: "القسمة المطولة",
    link: "/calculator/ar/long-division-calculator/",
    description:
      "استخدم حاسبة القسمة المطولة لإجراء عمليات القسمة الطويلة بسهولة. أدخل الأعداد المطلوبة للحصول على النتيجة خطوة بخطوة.",
  },
  {
    name: "آلة حاسبة",
    link: "/ar/calculators/",
    description:
      "استخدم الآلة الحاسبة لإجراء العمليات الحسابية الأساسية مثل الجمع والطرح والضرب والقسمة. يمكنك إدخال الأرقام والعمليات للحصول على النتائج بسرعة وسهولة.",
    showMain: false,
  },
  {
    name: "حاسبة الدوال المثلثية",
    link: "/calculator/ar/trigonometry/",
    description:
      " استخدم حاسبة الدوال المثلثية لحساب قيم الدوال المثلثية مثل الجيب وجيب التمام والظل. أدخل الزاوية المطلوبة للحصول على القيم بدقة.",
    showMain: false,
  },
];
export default mathCalculators;